import React from "react";
import { Subtitle } from "./Text";

const BackToTop = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <section className="">
            <h3 className="back-to-top-button" onClick={scrollToTop}
            >
              <Subtitle className="back-to-top">Back to Top</Subtitle>
            </h3>
          </section>
  );
};

export default BackToTop;
